/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as commonV1 from "./deviceapis_device_common_v1.pb"

/**
 * Сервис считывателей
 */

/**
 * Сервис считывателей
 */
export class ReaderServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод редактирования считывателя
   */
  EditReader = (req: Pick<EditReaderRequestDto, "updateMask"> & { data: Pick<ReaderRequestDto, "id"> & fm.RequireAtLeastOne<Omit<ReaderRequestDto, "id">> }, init?: RequestInit): Promise<EditReaderResponseDto> => {
    return fm.request<Pick<EditReaderRequestDto, "updateMask"> & { data: Pick<ReaderRequestDto, "id"> & fm.RequireAtLeastOne<Omit<ReaderRequestDto, "id">> }, EditReaderResponseDto>(`${this.host}/device/api/v1/reader/${encodeURIComponent(req.data.id)}`, { ...init, method: "PATCH", body: JSON.stringify(req.data, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения считывателя
   */
  GetReader = (req: GetReaderRequestDto, init?: RequestInit): Promise<GetReaderResponseDto> => {
    return fm.request<GetReaderRequestDto, GetReaderResponseDto>(`${this.host}/device/api/v1/reader/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Направление
 */
export enum ReaderDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * Вход
   */
  IN = "IN",
  /**
   * Выход
   */
  OUT = "OUT",
}
/**
 * Направление
 */
export type ReaderDirectionTypeResponseEnum = keyof typeof ReaderDirectionType
/**
 * Направление
 */
export type ReaderDirectionTypeRequestEnum = Exclude<ReaderDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Запрос редактирования считывателя
 */
export type EditReaderRequestDto = {
  /**
   * Считыватель
   */
  data: ReaderRequestDto
  /**
   * Маска полей обновления
   */
  updateMask?: string | null
}
/**
 * Ответ на запрос редактирования считывателя
 */
export type EditReaderResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: EditReaderResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type EditReaderResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
  /**
   * Ошибка сохранения
   */
  readonly saving: ReaderSavingErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type EditReaderResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
  /**
   * Ошибка сохранения
   */
  readonly saving: ReaderSavingErrorResponseDto
}>
/**
 * Запрос получения считывателя
 */
export type GetReaderRequestDto = {
  /**
   * Идентификатор.
   * id=100 - Считыватель внутренний.
   * id=1 - Считыватель внешний №1.
   * id=2 - Считыватель внешний №2 и тд
   */
  id: number
}
/**
 * Ответ на запрос получения считывателя
 */
export type GetReaderResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Считыватель
   */
  readonly data: ReaderResponseDto
}>
/**
 * Считыватель
 */
export type ReaderRequestDto = {
  /**
   * Идентификатор.
   * id=100 - Считыватель внутренний.
   * id=1 - Считыватель внешний №1.
   * id=2 - Считыватель внешний №2 и тд
   */
  id: number
  /**
   * Список идентификаторов профилей шифрования
   */
  encryptionProfileIds: number[]
  /**
   * Список идентификаторов реле.
   * Диапазон: 1..64
   */
  relayIndexes: number[]
  /**
   * Считыватель работает не в безопасном режиме (по UID)
   */
  isNoneSecureMode: boolean
  /**
   * Направление
   */
  directionType?: ReaderDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
}
/**
 * Считыватель
 */
export type ReaderResponseDto = {
  /**
   * Идентификатор.
   * id=100 - Считыватель внутренний.
   * id=1 - Считыватель внешний №1.
   * id=2 - Считыватель внешний №2 и тд
   */
  id: number
  /**
   * Список идентификаторов профилей шифрования
   */
  encryptionProfileIds: number[]
  /**
   * Список идентификаторов реле.
   * Диапазон: 1..64
   */
  relayIndexes: number[]
  /**
   * Считыватель работает не в безопасном режиме (по UID)
   */
  isNoneSecureMode: boolean
  /**
   * Направление
   */
  directionType: ReaderDirectionTypeResponseEnum
}
/**
 * Ошибки сохранения
 */
export type ReaderSavingErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Считыватель не найден
   */
  readonly readerNotFound: ReaderSavingErrorReaderNotFoundRequestDto
  /**
   * Профиль не поддерживается для этого считывателя
   */
  readonly profileIsNotSupported: ReaderSavingErrorProfileIsNotSupportedRequestDto
  /**
   * Выбранный профиль не найден
   */
  readonly profileNotFound: ReaderSavingErrorProfileNotFoundRequestDto
}>
/**
 * Ошибки сохранения
 */
export type ReaderSavingErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Считыватель не найден
   */
  readonly readerNotFound: ReaderSavingErrorReaderNotFoundResponseDto
  /**
   * Профиль не поддерживается для этого считывателя
   */
  readonly profileIsNotSupported: ReaderSavingErrorProfileIsNotSupportedResponseDto
  /**
   * Выбранный профиль не найден
   */
  readonly profileNotFound: ReaderSavingErrorProfileNotFoundResponseDto
}>
/**
 * Профиль не поддерживается для этого считывателя
 */
export type ReaderSavingErrorProfileIsNotSupportedRequestDto = {
  /**
   * Список идентификаторов профилей, которые не поддерживаются на считывателе
   */
  profileIds?: number[]
}
/**
 * Профиль не поддерживается для этого считывателя
 */
export type ReaderSavingErrorProfileIsNotSupportedResponseDto = {
  /**
   * Список идентификаторов профилей, которые не поддерживаются на считывателе
   */
  profileIds: number[]
}
/**
 * Выбранный профиль не найден
 */
export type ReaderSavingErrorProfileNotFoundRequestDto = {
}
/**
 * Выбранный профиль не найден
 */
export type ReaderSavingErrorProfileNotFoundResponseDto = {
}
/**
 * Считыватель не найден
 */
export type ReaderSavingErrorReaderNotFoundRequestDto = {
}
/**
 * Считыватель не найден
 */
export type ReaderSavingErrorReaderNotFoundResponseDto = {
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос редактирования считывателя
   */
  "EditReaderRequest": {
    "kind": "class",
    "text": "Запрос редактирования считывателя",
    "fields": {
      /**
       * Считыватель
       */
      "data": {
        "type": "Reader",
        "text": "Считыватель",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Маска полей обновления
       */
      "updateMask": {
        "type": "google.protobuf.FieldMask",
        "text": "Маска полей обновления",
      },
    },
  },
  /**
   * Ответ на запрос редактирования считывателя
   */
  "EditReaderResponse": {
    "kind": "class",
    "text": "Ответ на запрос редактирования считывателя",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "EditReaderResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "EditReaderResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Ошибка сохранения
       */
      "saving": {
        "type": "Reader.SavingError",
        "text": "Ошибка сохранения",
      },
    },
  },
  /**
   * Запрос получения считывателя
   */
  "GetReaderRequest": {
    "kind": "class",
    "text": "Запрос получения считывателя",
    "fields": {
      /**
       * Идентификатор.
       * id=100 - Считыватель внутренний.
       * id=1 - Считыватель внешний №1.
       * id=2 - Считыватель внешний №2 и тд
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор.\nid=100 - Считыватель внутренний.\nid=1 - Считыватель внешний №1.\nid=2 - Считыватель внешний №2 и тд",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения считывателя
   */
  "GetReaderResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения считывателя",
    "fields": {
      /**
       * Считыватель
       */
      "data": {
        "type": "Reader",
        "text": "Считыватель",
      },
    },
  },
  /**
   * Считыватель
   */
  "Reader": {
    "kind": "class",
    "text": "Считыватель",
    "fields": {
      /**
       * Идентификатор.
       * id=100 - Считыватель внутренний.
       * id=1 - Считыватель внешний №1.
       * id=2 - Считыватель внешний №2 и тд
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор.\nid=100 - Считыватель внутренний.\nid=1 - Считыватель внешний №1.\nid=2 - Считыватель внешний №2 и тд",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Список идентификаторов профилей шифрования
       */
      "encryptionProfileIds": {
        "type": "int32",
        "text": "Список идентификаторов профилей шифрования",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Список идентификаторов реле.
       * Диапазон: 1..64
       */
      "relayIndexes": {
        "type": "int32",
        "text": "Список идентификаторов реле.\nДиапазон: 1..64",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Считыватель работает не в безопасном режиме (по UID)
       */
      "isNoneSecureMode": {
        "type": "bool",
        "text": "Считыватель работает не в безопасном режиме (по UID)",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Направление
       */
      "directionType": {
        "type": "Reader.DirectionType",
        "text": "Направление",
      },
    },
  },
  /**
   * Ошибки сохранения
   */
  "Reader.SavingError": {
    "kind": "class",
    "text": "Ошибки сохранения",
    "fields": {
      /**
       * Считыватель не найден
       */
      "readerNotFound": {
        "type": "Reader.SavingError.ReaderNotFound",
        "text": "Считыватель не найден",
      },
      /**
       * Профиль не поддерживается для этого считывателя
       */
      "profileIsNotSupported": {
        "type": "Reader.SavingError.ProfileIsNotSupported",
        "text": "Профиль не поддерживается для этого считывателя",
      },
      /**
       * Выбранный профиль не найден
       */
      "profileNotFound": {
        "type": "Reader.SavingError.ProfileNotFound",
        "text": "Выбранный профиль не найден",
      },
    },
  },
  /**
   * Профиль не поддерживается для этого считывателя
   */
  "Reader.SavingError.ProfileIsNotSupported": {
    "kind": "class",
    "text": "Профиль не поддерживается для этого считывателя",
    "fields": {
      /**
       * Список идентификаторов профилей, которые не поддерживаются на считывателе
       */
      "profileIds": {
        "type": "int32",
        "text": "Список идентификаторов профилей, которые не поддерживаются на считывателе",
      },
    },
  },
  /**
   * Выбранный профиль не найден
   */
  "Reader.SavingError.ProfileNotFound": {
    "kind": "class",
    "text": "Выбранный профиль не найден",
  },
  /**
   * Считыватель не найден
   */
  "Reader.SavingError.ReaderNotFound": {
    "kind": "class",
    "text": "Считыватель не найден",
  },
  /**
   * Направление
   */
  "Reader.DirectionType": {
    "kind": "enum",
    "text": "Направление",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Вход
       */
      "IN": {
        "i": 1,
        "text": "Вход",
      },
      /**
       * Выход
       */
      "OUT": {
        "i": 2,
        "text": "Выход",
      },
    },
  },
}